'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { ClubBadge } from '~/components/Account/Rewards';
import loyaltyBenefitsStyles from '~/components/Journey/Loyalty/LoyaltyBenefitsSection.module.css';
import { Link } from '~/components/Link';
import { getLocalisedTierName, getLoyaltyBenefitsDescription } from '~/utils/loyaltyBenefitsCopy';
import { useTripLoyaltyPricing } from '../hooks/useTripLoyaltyPricing';
export const TripLoyaltyBenefitsSection = () => {
  const $ = _c(27);
  const t = useTranslations("journey");
  const tAccount = useTranslations("account");
  const tCommon = useTranslations("common");
  const loyalty = useTripLoyaltyPricing();
  if (!loyalty.hasLoyaltyDiscount) {
    return null;
  }
  let t0;
  if ($[0] !== loyalty.loyaltyDiscount || $[1] !== loyalty.loyaltyTierId || $[2] !== loyalty.loyaltyTierName || $[3] !== t || $[4] !== tAccount) {
    t0 = getLoyaltyBenefitsDescription(t, loyalty.loyaltyTierId, {
      discount: loyalty.loyaltyDiscount,
      tier: getLocalisedTierName(tAccount, loyalty.loyaltyTierId, loyalty.loyaltyTierName as string)
    });
    $[0] = loyalty.loyaltyDiscount;
    $[1] = loyalty.loyaltyTierId;
    $[2] = loyalty.loyaltyTierName;
    $[3] = t;
    $[4] = tAccount;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const description = t0;
  let t1;
  if ($[6] !== t) {
    t1 = t("loyalty_benefits_club_badge");
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <ClubBadge>{t1}</ClubBadge>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t) {
    t3 = t("loyalty_benefits_heading");
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <h3 className={loyaltyBenefitsStyles.heading}>{t3}</h3>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = <div className={loyaltyBenefitsStyles.headingRow}>{t2}{t4}</div>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== tCommon) {
    t6 = tCommon("learn_more");
    $[17] = tCommon;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t6) {
    t7 = <Link href="/account/rewards" hasUnderline={true}><span className={loyaltyBenefitsStyles.learnMore}>{t6}.</span></Link>;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== description || $[22] !== t7) {
    t8 = <p className={loyaltyBenefitsStyles.description}>{description}{" "}{t7}</p>;
    $[21] = description;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t5 || $[25] !== t8) {
    t9 = <section className={loyaltyBenefitsStyles.section} data-test-id="trip-loyalty-benefits-section">{t5}{t8}</section>;
    $[24] = t5;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};